import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { IdexService } from "../../../../idex.service";
import { DefaultTo } from "../../../../shared/defaultTo.decorator";
import { zDoxItem } from "../../../../shared/types";
import {
   MetadataFormMode,
   MetadataFormProperty,
   MetadataFormType,
} from "../viewer-info-panel.types";

@Injectable({
   providedIn: "root",
})
export class MetadataService {
   doc: zDoxItem;

   @DefaultTo(true) enableTab: boolean;
   @DefaultTo("selectType") mode: MetadataFormMode = "selectType";
   formType: MetadataFormType;
   typeOptions: MetadataFormType[];
   properties: MetadataFormProperty[];
   properties$ = new BehaviorSubject<MetadataFormProperty[]>(undefined);
   @DefaultTo(true) canEdit: boolean;

   constructor(public service: IdexService) {}

   initMetadata(doc: zDoxItem) {
      this.doc = doc;
      this.onDocUpdate(doc);
   }

   private onDocUpdate(doc: zDoxItem) {
      this.canEdit = doc.permissions?.edit;
      this.service.getTypes().subscribe(
         (dataType) => {
            this.typeOptions = dataType;
         },
         (error) => {},
         () => {
            this.enableTab = !!(
               doc.typeName ||
               (this.typeOptions && this.canEdit)
            );
            this.mode = doc.typeName ? "setProperties" : "selectType";
            this.formType = { name: doc.type, title: doc.typeName };
            this.properties = doc.properties;
            this.properties$.next(this.properties);
         }
      );
   }

   saveType(
      docId: zDoxItem["id"],
      formType: MetadataFormType,
      properties: MetadataFormProperty[]
   ): Subject<boolean> {
      const saveSuccess$ = new Subject<boolean>();
      const data = {
         type: formType.name,
         properties: properties,
      };
      this.service.setType(docId, data).subscribe(
         (properties) => {
            this.mode = "setProperties";
            this.formType = {
               name: formType.name,
               title: formType.title,
            };
            this.properties = properties;
            this.properties$.next(this.properties);
            saveSuccess$.next(true);
         },
         (error) => {
            saveSuccess$.next(false);
         },
         () => {
            saveSuccess$.complete();
         }
      );
      return saveSuccess$;
   }

   saveProperties(properties: MetadataFormProperty[]): Subject<boolean> {
      const saveSuccess$ = new Subject<boolean>();
      this.service.setMetadata(this.doc.id, properties).subscribe(
         (data) => {
            this.doc.properties = data;
            saveSuccess$.next(true);
         },
         (error) => {
            saveSuccess$.next(false);
         },
         () => {
            saveSuccess$.complete();
         }
      );
      return saveSuccess$;
   }
}
